import "./Header.css"

function Header(){
    return <header className="header">

        <img src="/Img/Header.png" alt='Org'/>

    </header>

    

}
export default Header